module.exports = __webpack_public_path__ + "static/media/ptwoo.94a77041.png";